import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { SequencingSettings } from 'features/settings/components/SequencingSettings'
import { SenderEmailSettings } from 'features/settings/components/SenderEmailSettings'
import { CompanyDomainsTable } from 'features/settings/components/CompanyDomainsTable'
import { useAuth } from 'context/authentication/useAuth'
import { useMemo } from 'react'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

const DEFAULT_TAB = 'sequencing'

export function OutreachSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = params.tab ?? DEFAULT_TAB
  const { isAllowed } = useAuth()
  const isReadOnly = !isAllowed('Admin')
  const featureFlags = useFeatureFlagService()

  const tabs = useMemo(() => {
    const allTabs: { key: string; title: string }[] = [
      { key: 'sequencing', title: 'Sequencing' },
      { key: 'email-outreach', title: 'Email Outreach' },
    ]

    if (featureFlags.enableCompanyEmailExtensionSettings) {
      allTabs.push({ key: 'domains', title: 'Domains' })
    }

    return allTabs
  }, [featureFlags.enableCompanyEmailExtensionSettings])

  const validTabs = useMemo(() => new Set(tabs.map((t) => t.key)), [tabs])

  if (params.tab && !validTabs.has(params.tab)) {
    return <Navigate to={`/settings/outreach/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) => navigate(`/settings/outreach/${value}`)}
          tabStyle={{ width: '150px' }}
        />
      </FBPageInnerTabsContainer>
      {tab === 'sequencing' && (
        <FBPageTableContainer>
          <SequencingSettings />
        </FBPageTableContainer>
      )}
      {tab === 'email-outreach' && (
        <FBPageTableContainer>
          <SenderEmailSettings />
        </FBPageTableContainer>
      )}
      {tab === 'domains' && (
        <FBPageTableContainer>
          <CompanyDomainsTable disabled={isReadOnly} />
        </FBPageTableContainer>
      )}
    </div>
  )
}
